export const categories = [
  {
    id: "small-business",
    label: "Small Business",
    subcategories: [
      "General Services",
      "Consulting",
      "Retail Shop",
      "Cafe / Restaurant",
      "Health & Beauty",
      "Local Trades",
      "Professional Services",
      "Online Business",
      "Franchise",
      "Other"
    ]
  },
  {
    id: "trades",
    label: "Trades",
    subcategories: ["Electrician", "Plumber", "Carpenter", "Landscaper", "Builder", "Painter", "Other"]
  },
  {
    id: "home-services",
    label: "Home Services",
    subcategories: ["Cleaning", "Pest Control", "Gardening", "Moving", "Repair Services", "Other"]
  },
  {
    id: "hospitality",
    label: "Hospitality",
    subcategories: ["Hotel", "Motel", "Vacation Rental", "Bed & Breakfast", "Hostel", "Other"]
  },
  {
    id: "medical",
    label: "Medical",
    subcategories: ["Clinic", "Dental Practice", "Physiotherapy", "Specialist Practice", "Pharmacy", "Other"]
  },
  {
    id: "professional",
    label: "Professional",
    subcategories: ["Law Firm", "Accounting", "Real Estate", "Financial Advisor", "Marketing Agency", "Other"]
  },
  {
    id: "personal-services",
    label: "Personal Services",
    subcategories: ["Personal Training", "Tutoring", "Life Coaching", "Pet Services", "Event Planning", "Other"]
  },
  {
    id: "web-tool",
    label: "Web Tool",
    subcategories: ["SaaS", "Utility", "API Service", "Data Visualization", "Calculator", "Other"]
  },
  {
    id: "crm",
    label: "CRM",
    subcategories: ["Sales CRM", "Support Desk", "Contact Management", "Project Management", "Other"]
  },
  {
    id: "calendar-events",
    label: "Calendar & Events",
    subcategories: ["Booking System", "Event Calendar", "Ticketing Platform", "Scheduling Tool", "Other"]
  },
  {
    id: "e-commerce",
    label: "E-Commerce",
    subcategories: ["Fashion", "Electronics", "Digital Goods", "Marketplace", "Subscription Box", "Other"]
  },
  {
    id: "directory",
    label: "Directory",
    subcategories: ["Business Listings", "Job Board", "Real Estate Listings", "Event Directory", "Other"]
  },
  {
    id: "accommodation",
    label: "Accommodation",
    subcategories: ["Hotel Booking", "Vacation Rentals", "Property Listings", "Roommate Finder", "Other"]
  },
  {
    id: "mobile-app",
    label: "Mobile App",
    subcategories: ["Companion App", "Standalone App Landing Page", "App Showcase", "PWA", "Other"]
  },
  {
    id: "cms",
    label: "CMS",
    subcategories: ["Blog", "News Site", "Portfolio", "Knowledge Base", "Documentation", "Other"]
  },
  {
    id: "cloud-storage",
    label: "Cloud Storage",
    subcategories: ["File Hosting", "Photo Gallery", "Document Management", "Digital Asset Manager", "Other"]
  },
  {
    id: "coaching",
    label: "Coaching",
    subcategories: ["Business Coaching", "Life Coaching", "Fitness Coaching", "Course Portal", "Other"]
  },
  {
    id: "lms",
    label: "LMS",
    subcategories: ["Online Courses", "Corporate Training", "School System", "Skill Assessment", "Other"]
  },
  {
    id: "productivity",
    label: "Productivity",
    subcategories: ["To-Do List", "Note Taking", "Time Tracking", "Habit Tracker", "Project Management", "Other"]
  },
  {
    id: "automation",
    label: "Automation",
    subcategories: ["Workflow Automation", "Social Media Scheduler", "Data Scraper", "Integration Platform", "Other"]
  },
  {
    id: "other",
    label: "Other",
    subcategories: ["Community Forum", "Non-Profit", "Personal Blog", "Event Site", "Other"]
  }
];